import { render, staticRenderFns } from "./ReferenceDeleteDialog.vue?vue&type=template&id=99f03b78&scoped=true"
import script from "./ReferenceDeleteDialog.vue?vue&type=script&lang=ts"
export * from "./ReferenceDeleteDialog.vue?vue&type=script&lang=ts"
import style0 from "./ReferenceDeleteDialog.vue?vue&type=style&index=0&id=99f03b78&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99f03b78",
  null
  
)

export default component.exports